<template><div><h1 id="eb-buchungsjournal-nach-filter" tabindex="-1"><a class="header-anchor" href="#eb-buchungsjournal-nach-filter"><span>EB-Buchungsjournal nach Filter</span></a></h1>
<p>EB-Buchungsjournal nach Filter — Einzelbuchungen für die Kombination Konto / Kostenstelle / Kostenträger</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung zeigt alle Einzelbuchungen für die Kombination Konto / Kostenstelle / Kostenträger und berechnet den Saldo pro Kunde (Personen-ID) oder Fakturanummer. Einschränkungen nach verschiedensten Parametern möglich. Wenn der Parameter &quot;detaillierte EB&quot; auf &quot;ja&quot; gesetzt ist, werden auch die Einzelbuchungen im gleichen Format wie in der Maske Einzelbuchungen auf dem Bildschirm angezeigt. Sortierung der Einzelbuchungen nach Personen-ID oder Fakturanummer. Wenn der Parameter &quot;Teilsaldo&quot; auf &quot;ja&quot; gesetzt ist, wird für jede Adresse oder Faktura (Sortierung nach) auch der Saldo angezeigt.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → EB-Kontoauszüge → EB-Buchungsjournal nach Filter</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID von:</dt>
<dd>
<p>Personen-ID, inklusive, wenn ? offen</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Personen-ID, inklusive, wenn ? offen</p>
</dd>
<dt>Fakturanummer von:</dt>
<dd>
<p>Fakturanummer, inklusive, wenn ? offen</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Fakturanummer, inklusive, wenn ? offen</p>
</dd>
<dt>Journalnummer von:</dt>
<dd>
<p>Journalnummer, inklusive, wenn ? offen</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Journalnummer, inklusive, wenn ? offen</p>
</dd>
<dt>Absolutbetrag von:</dt>
<dd>
<p>Einzelbuchungsbetrag, inklusive, Begrenzung von unten, wenn ? offen</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Einzelbuchungsbetrag, inklusive, Begrenzung nach oben, wenn ? offen</p>
</dd>
<dt>Belegdatum von:</dt>
<dd>
<p>Datum der Einzelbuchung, inklusive, wenn ? offen</p>
</dd>
<dt>bis:</dt>
<dd>
<p>Datum der Einzelbuchung, inklusive, wenn ? offen</p>
</dd>
<dt>Adressfilter:</dt>
<dd>
<p>Einschränkung auf Adressen in Filter, leer = alle</p>
</dd>
<dt>EB-Typen:</dt>
<dd>
<p>Einschränkung auf bestimmte Einzelbuchungstypen, mit Komma trennen, mit ! ausschliessen, * oder leer = alle</p>
</dd>
<dt>Habenkonti:</dt>
<dd>
<p>Einschränkung auf bestimmte Habenkonti, mit Komma trennen, mit ! ausschliessen, * oder leer = alle</p>
</dd>
<dt>Sollkonti:</dt>
<dd>
<p>Einschränkung auf bestimmte Sollkonti, mit Komma trennen, mit ! ausschliessen, * oder leer = alle</p>
</dd>
<dt>Kostenstellen:</dt>
<dd>
<p>Einschränkung auf bestimmte Kostenstellen, mit Komma trennen, mit ! ausschliessen, * oder leer = alle</p>
</dd>
<dt>erfasst durch:</dt>
<dd>
<p>Einschränkung auf Erfasser, mit Komma trennen, mit ! ausschliessen, * oder leer = alle</p>
</dd>
<dt>Sortierung nach:</dt>
<dd>
<p>Sortierung der Werte nach:</p>
</dd>
<dd>
<p>E)B-typ: Einzelbuchungstyp, absteigend von ZS-AS;Z-A</p>
</dd>
<dd>
<p>H)abenKto: Habenkonti, aufsteigend</p>
</dd>
<dd>
<p>S)ollKto: Sollkonti, aufsteigend</p>
</dd>
<dd>
<p>A)drNr.: Personen-ID, aufsteigend</p>
</dd>
<dd>
<p>F)aktNr.: Fakturanummer, aufsteigend</p>
</dd>
<dd>
<p>J)ourNr: Journalnummer, aufsteigendInnerhalb dieser Grobsortierung wird so sortiert, dass die jeweils neueste Information zuerst erscheint (siehe Outputbeispiel). Zusammengehörende Informationen werden gemeinsam belassen, so dass eine Übersicht über einen Geschäftsfall (Fakturanummer) immer gegeben ist.</p>
</dd>
<dt>Teilsaldi:</dt>
<dd>
<p>ja = Gibt - abhängig von der gewählten Sortierung - Teilsummen pro Einzelwert aus (Standard)nein = zeigt keine Teilsummen für die gewählte Sortierung = reines Protokoll der vorhandenen Buchungen</p>
</dd>
<dt>detaillierte EB:</dt>
<dd>
<p>ja = zeigt alle Einzelbuchungen an, die den gewählten Parametern entsprechen (Standard)nein = es werden nur Teilsaldi ausgewiesen (nur möglich bei Teilsaldi = ja)</p>
</dd>
</dl>
<p>:</p>
<dl>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
<dt>Bildschirm:</dt>
<dd>ja</dd>
<dt>Drucker/Format:</dt>
<dd>A4 hoch</dd>
<dt>Hintergrundverarb.:</dt>
<dd>ja</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Spalten:</td>
<td>nur wenn der Parameter &quot;detaillierte EB&quot; auf &quot;ja&quot; gesetzt ist</td>
</tr>
<tr>
<td>- FaktNum:</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>- T:</td>
<td>Einzelbuchungstyp</td>
</tr>
<tr>
<td>- Sollkonto:</td>
<td>bebuchtes Sollkonto</td>
</tr>
<tr>
<td>- Habenkonto:</td>
<td>bebuchtes Habenkonto</td>
</tr>
<tr>
<td>- Kostenstelle:</td>
<td>bebuchte Kostenstelle</td>
</tr>
<tr>
<td>- Kostenträger:</td>
<td>bebuchter Kostenträger</td>
</tr>
<tr>
<td>- Betrag:</td>
<td>gebuchter Betrag</td>
</tr>
<tr>
<td>- Buchungstext:</td>
<td>Buchungstext</td>
</tr>
<tr>
<td>- AdrNum:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>- AufNum:</td>
<td>Auftragsnummer</td>
</tr>
<tr>
<td>- Pos:</td>
<td>Auftragsposition, Einzelbuchungen aus dem Auftrag haben hier die Nummer aus der Auftragsposition</td>
</tr>
<tr>
<td>- M:</td>
<td>ehrwertsteuer- Code</td>
</tr>
<tr>
<td>- Datum:</td>
<td>Buchungsdatum</td>
</tr>
<tr>
<td>- JourNr:</td>
<td>Journalnummer</td>
</tr>
<tr>
<td>- S:</td>
<td>Status</td>
</tr>
<tr>
<td></td>
<td></td>
</tr>
<tr>
<td>Totale/Subtotale:</td>
<td>nur wenn der Parameter &quot;Teilsaldo&quot; auf &quot;ja&quot; gesetzt ist</td>
</tr>
<tr>
<td>- Saldo:</td>
<td>Teilsaldo für Adresse oder Faktura - abhängig vom Parameter &quot;Sortierung nach&quot;</td>
</tr>
<tr>
<td>- Gesamtsaldo:</td>
<td>Saldo des Berichts</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel mit detaillierten Einzelbuchungen und mit Teilsaldo pro Adresse</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                10.11.1998 14:23:58 mop  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                       EB-Buchungsprotokoll nach Filter</span>
<span class="line">                 von Faktura.....:       0    bis:       0</span>
<span class="line">                 von Personen-ID: 3          bis: 5</span>
<span class="line">                 von Datum.......:            bis:</span>
<span class="line">                 Adr. mit Merkmal:</span>
<span class="line">                 Anlage-ID.......: !,\*</span>
<span class="line">                 Sortierung nach.: A</span>
<span class="line">                 detaillierte EB.: ja</span>
<span class="line">                 Teilsaldo.......: ja</span>
<span class="line"></span>
<span class="line">                                Einzelbuchungen</span>
<span class="line">FaktNum T  Sollkonto    Habenkonto   Kostenstelle Kostenträger          Betrag</span>
<span class="line">           Buchungstext                 AdrNum  AufNum Pos M Datum    JourNr S</span>
<span class="line">------------------------------------------------------------------------------</span>
<span class="line"> 402100 Z  1900         1100.990                                        300.00</span>
<span class="line">           Zahlung                                   0   0   15.08.97   1003 1</span>
<span class="line"> 402100 S  1100.990     3600         8800                                10.00</span>
<span class="line">           Spende                                    0   0   10.03.97   1003 1</span>
<span class="line"> .</span>
<span class="line"> .</span>
<span class="line"> .</span>
<span class="line">2002040 E  4450         1100.990                                        132.00</span>
<span class="line">           Erlösminderungsgutschrift           1016417   0   03.04.97   1003 1</span>
<span class="line"></span>
<span class="line">Personen-ID.:          3     Saldo/Adresse:          42.00</span>
<span class="line"></span>
<span class="line">                                Einzelbuchungen</span>
<span class="line">FaktNum T  Sollkonto    Habenkonto   Kostenstelle Kostenträger          Betrag</span>
<span class="line">           Buchungstext                 AdrNum  AufNum Pos M Datum    JourNr S</span>
<span class="line">------------------------------------------------------------------------------</span>
<span class="line">      0 Z  1900         1100.990                                        100.00</span>
<span class="line">           Zahlung                                   0   0   24.04.97   1003 1</span>
<span class="line">      0 GS 1100.990     2098                                            100.00</span>
<span class="line">           Storno Guthaben Warenverka                0   0   24.04.97   1003 1</span>
<span class="line">     50 Z  1900         1100.990                                        200.00</span>
<span class="line">           Zahlung                                   0   0   24.04.97   1003 1</span>
<span class="line">     50 GS 1100.990     2098                                            200.00</span>
<span class="line">           Storno Guthaben Warenverka                0   0   24.04.97   1003 1</span>
<span class="line"> 402800 S  1100.990     3600         8800                                31.00</span>
<span class="line">           Spende                                    0   0   16.06.97   1003 1</span>
<span class="line"> 402800 Z  1900         1100.990                                         25.00</span>
<span class="line">           Zahlung                                   0   0   16.06.97   1003 1</span>
<span class="line"> 402800 S  1100.990     3600         8800                                25.00</span>
<span class="line">           Spende                                    0   0   16.06.97   1003 1</span>
<span class="line"> 402800 Z  1900         1100.990                                         31.00</span>
<span class="line">           Zahlung                                   0   0   16.06.97   1003 1</span>
<span class="line">2002131 G  2098         1100.990                                        100.00</span>
<span class="line">           Guthaben Warenverkauf               1023752   0   25.09.97   1003 1</span>
<span class="line">2002206 GS 1100.990     2098                                             32.00</span>
<span class="line">           Storno Guthaben Warenverka          1023802   0   06.11.97   1003 1</span>
<span class="line"></span>
<span class="line">Personen-ID.:          5     Saldo/Adresse:          68.00</span>
<span class="line"></span>
<span class="line">-----------------------------</span>
<span class="line">Gesamtsaldo..:         110.00</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Outputbeispiel ohne detaillierte Einzelbuchungen, mit Teilsaldo pro Adresse</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                10.11.1998 14:24:13 mop  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                       EB-Buchungsprotokoll nach Filter</span>
<span class="line">                 von Faktura.....:       0    bis:       0</span>
<span class="line">                 von Personen-ID: 3          bis: 5</span>
<span class="line">                 von Datum.......:            bis:</span>
<span class="line">                 Adr. mit Merkmal:</span>
<span class="line">                 Anlage-ID.......: !,\*</span>
<span class="line">                 Sortierung nach.: A</span>
<span class="line">                 detaillierte EB.: nein</span>
<span class="line">                 Teilsaldo.......: ja</span>
<span class="line"></span>
<span class="line">Personen-ID.:          3     Saldo/Adresse:          42.00</span>
<span class="line"></span>
<span class="line">Personen-ID.:          5     Saldo/Adresse:          68.00</span>
<span class="line"></span>
<span class="line">-----------------------------</span>
<span class="line">Gesamtsaldo..:         110.00</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Outputbeispiel mit Teilsaldo pro EB-Typ</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                                24.08.1999 10:58:12 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                       EB-Buchungsprotokoll nach Filter</span>
<span class="line">                Personen-ID  von: 485,177    bis: 485,177</span>
<span class="line">                Fakturanummer von:       0    bis: 9999999</span>
<span class="line">                Journalnummer von: ?          bis: |</span>
<span class="line">                Absolutbetrag von: ?          bis: |</span>
<span class="line">                Belegdatum    von:            bis:</span>
<span class="line">                Adressfilter.....: 0</span>
<span class="line">                EB-Typen.........: \*</span>
<span class="line">                Habenkonti.......: \*</span>
<span class="line">                Sollkonti........: \*</span>
<span class="line">                erfasst durch....: \*</span>
<span class="line">                Sortierung nach..: E</span>
<span class="line">                Teilsaldi........: ja</span>
<span class="line">                detaillierte EB..: nein</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">EB-Typ: A  Saldo:          27.50</span>
<span class="line">EB-Typ: G  Saldo:          -2.50</span>
<span class="line">EB-Typ: GS Saldo:           2.50</span>
<span class="line">EB-Typ: R  Saldo:           2.50</span>
<span class="line">EB-Typ: Z  Saldo:         -30.00</span>
<span class="line">------------------------------</span>
<span class="line">Gesamtsaldo..: 0.00</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Outputbeispiel ohne detaillierte EB und ohne Teilsaldo pro Adresse</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                                17.02.1999 15:40:56 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                       EB-Buchungsprotokoll nach Filter</span>
<span class="line">                 von Faktura.....:       0    bis:       0</span>
<span class="line">                 von Personen-ID: 1,000      bis: 2,000</span>
<span class="line">                 von Datum.......: 01.01.1998 bis: 30.06.1998</span>
<span class="line">                 Adr. mit Merkmal:</span>
<span class="line">                 Anlage-ID.......: !,\*</span>
<span class="line">                 Sortierung nach.: A</span>
<span class="line">                 detaillierte EB.: nein</span>
<span class="line">                 Teilsaldo.......: nein</span>
<span class="line"></span>
<span class="line">-----------------------------</span>
<span class="line">Gesamtsaldo..:           0.00</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


